/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PollOption } from './PollOption';
import type { PollTallyItem } from './PollTallyItem';
/**
 * Presenter view — the stable room, its join code/QR, and the live question + tally.
 */
export type PollRoom = {
    joinCode?: string;
    joinUrl?: string;
    /**
     * QR code as a data: URI (image/png)
     */
    qrPng?: string;
    status?: PollRoom.status;
    sessionId?: string;
    lessonId?: string;
    questionId?: string;
    question?: string;
    /**
     * single = one choice per voter; multi = several
     */
    qtype?: PollRoom.qtype;
    /**
     * Live-block kind. poll covers bars/spectrum/rating/reactions; wordcloud collects free text.
     */
    kind?: PollRoom.kind;
    /**
     * Render hint for the projector: '' (bars) | spectrum | rating | reactions.
     */
    display?: string;
    /**
     * Spectrum pole captions [left, right].
     */
    labels?: Array<string>;
    options?: Array<PollOption>;
    tally?: Array<PollTallyItem>;
};
export namespace PollRoom {
    export enum status {
        OPEN = 'open',
        CLOSED = 'closed',
    }
    /**
     * single = one choice per voter; multi = several
     */
    export enum qtype {
        SINGLE = 'single',
        MULTI = 'multi',
    }
    /**
     * Live-block kind. poll covers bars/spectrum/rating/reactions; wordcloud collects free text.
     */
    export enum kind {
        POLL = 'poll',
        WORDCLOUD = 'wordcloud',
        QA = 'qa',
    }
}

